import { QueryFunctionContext } from '@tanstack/react-query'
import { MsxService } from 'shared/services/MsxService'
import { DEFAULT_QUANTITIES_QUERY_KEY } from 'shared/constants'
import type { MTT } from 'shared/types/vp/mtt'

export const QUERY_KEY = DEFAULT_QUANTITIES_QUERY_KEY

export const queryDefaultQuantities = (
  context: QueryFunctionContext<MTT.Queries.MsxService.DefaultQuantitiesQueryKey>,
): Promise<MTT.Models.MsxService.DefaultQuantitiesResult | null> => {
  const { queryKey } = context
  const [_, { productKey, version, tenant, locales }] = queryKey

  return MsxService.getDefaultQuantities(tenant, locales, productKey, version)
}
